const DESKTOP_BREAKPOINT = 992;

function initOnThisPage() {
  const nav = document.querySelector('.on-this-page');
  if (!nav) return;

  const links = nav.querySelectorAll('.on-this-page__links a');
  if (!links.length) return;

  const trigger = document.querySelector('.on-this-page-trigger');
  const parent = document.querySelector('.page-main-content');
  const siteHeader = document.querySelector('.site-header');
  const indicator = document.querySelector('.reading-progress-indicator');

  function getNavTopOffset() {
    let offset = 16;

    if (siteHeader) {
      const headerHeight = siteHeader.offsetHeight;
      const stickyOffset = getComputedStyle(siteHeader).getPropertyValue('--sticky-header-offset');
      const stickyOffsetValue = stickyOffset ? Math.abs(parseFloat(stickyOffset)) || 0 : 0;
      offset += headerHeight - stickyOffsetValue;
    }

    const drupalOffset = getComputedStyle(document.documentElement).getPropertyValue('--drupal-displace-offset-top');
    if (drupalOffset) {
      offset += parseFloat(drupalOffset) || 0;
    }

    if (indicator && indicator.classList.contains('is-visible')) {
      offset += indicator.offsetHeight;
    }

    return offset;
  }

  let isSticky = false;
  let isHidden = false;

  function applySticky() {
    if (window.innerWidth < DESKTOP_BREAKPOINT) return;
    isSticky = true;
    const navTopOffset = getNavTopOffset();
    nav.classList.add('is-sticky');
    nav.style.top = navTopOffset + 'px';
    nav.style.left = nav.parentElement.getBoundingClientRect().left + 'px';
  }

  function removeSticky() {
    isSticky = false;
    nav.classList.remove('is-sticky', 'is-hidden');
    nav.style.top = '';
    nav.style.left = '';
  }

  // Observer 1: Watch trigger element to toggle sticky
  // Recreate observer when offset changes (e.g. reading progress indicator appears)
  let triggerObserver = null;
  let lastRootMargin = 0;

  function setupTriggerObserver() {
    const offset = getNavTopOffset();
    if (triggerObserver && offset === lastRootMargin) return;

    if (triggerObserver) {
      triggerObserver.disconnect();
    }

    lastRootMargin = offset;

    triggerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (window.innerWidth < DESKTOP_BREAKPOINT) {
            removeSticky();
            return;
          }

          if (entry.isIntersecting) {
            removeSticky();
          } else if (entry.boundingClientRect.top < offset + 10) {
            // Only sticky when trigger scrolled above the viewport (not below)
            applySticky();
          }
        });
      },
      {
        rootMargin: `-${offset}px 0px 0px 0px`,
      },
    );

    triggerObserver.observe(trigger);
  }

  if (trigger) {
    setupTriggerObserver();

    // Re-check rootMargin on scroll in case indicator visibility changed
    window.addEventListener(
      'scroll',
      () => {
        if (trigger) setupTriggerObserver();
        // Update fixed top position if sticky and offset changed
        if (isSticky && !isHidden) {
          const navTopOffset = getNavTopOffset();
          nav.style.top = navTopOffset + 'px';
          nav.style.left = nav.parentElement.getBoundingClientRect().left + 'px';
        }
      },
      { passive: true },
    );
  }

  // Observer 2: Watch .page-main-content to hide when bottom passes 75% of screen
  if (parent) {
    const parentObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (window.innerWidth < DESKTOP_BREAKPOINT) return;

          if (entry.isIntersecting) {
            isHidden = false;
            nav.classList.remove('is-hidden');
          } else if (entry.boundingClientRect.bottom < window.innerHeight * 0.75) {
            isHidden = true;
            nav.classList.add('is-hidden');
          }
        });
      },
      {
        rootMargin: '-75% 0px 0px 0px',
      },
    );

    parentObserver.observe(parent);
  }

  // Active link tracking
  function currentAnchor() {
    const winY = window.pageYOffset;
    let current = null;

    links.forEach((link) => {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      const target = document.getElementById(href.substring(1));
      if (!target) return;
      if (target.getBoundingClientRect().top + window.pageYOffset < winY + window.innerHeight * 0.23) {
        current = link;
      }
    });

    return current;
  }

  function updateActiveLink() {
    if (window.innerWidth < DESKTOP_BREAKPOINT) return;
    links.forEach((link) => link.closest('li')?.classList.remove('is-active'));
    const active = currentAnchor();
    if (active) {
      active.closest('li')?.classList.add('is-active');
    }
  }

  // Smooth scroll on click
  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      const target = document.getElementById(href.substring(1));
      if (!target) return;

      e.preventDefault();
      const offset = getNavTopOffset();
      const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

  updateActiveLink();

  window.addEventListener('scroll', updateActiveLink, { passive: true });

  // Update layout position on resize if sticky
  window.addEventListener(
    'resize',
    () => {
      if (isSticky && !isHidden && window.innerWidth >= DESKTOP_BREAKPOINT) {
        nav.style.left = nav.parentElement.getBoundingClientRect().left + 'px';
      } else if (window.innerWidth < DESKTOP_BREAKPOINT) {
        removeSticky();
      }
    },
    { passive: true },
  );
}

window.addEventListener('DOMContentLoaded', () => {
  initOnThisPage();
});
